import { render, staticRenderFns } from "./RecordingServers.vue?vue&type=template&id=47f4dc04&scoped=true"
import script from "./RecordingServers.vue?vue&type=script&lang=js"
export * from "./RecordingServers.vue?vue&type=script&lang=js"
import style0 from "./RecordingServers.vue?vue&type=style&index=0&id=47f4dc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4dc04",
  null
  
)

export default component.exports